import * as React from 'react';

import * as styles from './CardGallery.css';
import { CardGalleryMainMedia } from './internal/components/CardGalleryMainMedia';
import { CardThumbnails } from './internal/components/CardThumbnails';
import { IFavoriteEntityMedia } from '../../types/results';

const THUMBNAILS_MIN_MEDIA_COUNT = 4;

export interface ICardGalleryProps {
  media: IFavoriteEntityMedia[];
  alt: string;
  url: string;
  children?: React.ReactNode;
}

export const CardGallery: React.FC<ICardGalleryProps> = ({ media, alt, url, children }) => {
  return (
    <div className={styles['container']} data-name="CardGallery" data-testid="CardGallery">
      <div className={styles['main']}>
        <CardGalleryMainMedia media={media} alt={alt} url={url} />
        {children}
      </div>
      {media.length >= THUMBNAILS_MIN_MEDIA_COUNT && (
        <CardThumbnails media={media.slice(1, THUMBNAILS_MIN_MEDIA_COUNT)} />
      )}
    </div>
  );
};
